import { defineMessages } from "react-intl";

const messages = defineMessages({
    h1: {
        id: "choir.landing.hero.h1",
    },
    applicantsH1: {
        id: "choir.landing.hero.h1.applicants",
    },
    h2: {
        id: "choir.landing.hero.h2",
    },
    applicantsH2: {
        id: "choir.landing.hero.h2.applicants",
    },
    toClassroomEducation: {
        id: "memory.landing.hero.toClassroomEducation",
    },
    forChoirs: {
        id: "choir.forChoirs",
    },
});

export default messages;
